export const STENTOR_CURRENT_VERSION_NUMBER = "STENTOR_CURRENT_VERSION_NUMBER";

export interface StentorVersion {
    current: string;
    timesSeen: number;
}

function getStentorVersion(): StentorVersion {
    if (!localStorage) { return; }

    return JSON.parse(localStorage.getItem(STENTOR_CURRENT_VERSION_NUMBER)) || { current: __VERSION__, timesSeen: 0 };
}

export function displayWhatsNewCTA() {
    if (!localStorage) { return; }

    const stentorVersion: StentorVersion = getStentorVersion();
    const browserVersion = parseFloat(stentorVersion.current);
    const codeVersion = parseFloat(__VERSION__);

    return browserVersion !== codeVersion || stentorVersion.timesSeen === 0;
}

export function setCurrentVersion() {
    if (!localStorage) { return; }

    const stentorVersion: StentorVersion = getStentorVersion();

    stentorVersion.current = __VERSION__;
    stentorVersion.timesSeen = 1;
    localStorage.setItem(STENTOR_CURRENT_VERSION_NUMBER, JSON.stringify(stentorVersion));
}

export function setTimesSeen() {
    if (!localStorage) { return; }

    const stentorVersion: StentorVersion = getStentorVersion();

    stentorVersion.timesSeen = stentorVersion.timesSeen += 1;
    localStorage.setItem(STENTOR_CURRENT_VERSION_NUMBER, JSON.stringify(stentorVersion));
}
